<template>
  <v-card>
    <div class="modal-header">
      <v-btn
        icon
        class="close-button"
        @click="closeModal"
      >
        <v-icon size="30">
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </div>
    <div class="pt-12 pb-10 px-12">
      <div
        class="d-flex align-center mb-6"
        style="gap: 15px;"
      >
        <v-icon
          size="24"
          color="#C48EFF"
        >
          {{ icons.mdiSpeedometer }}
        </v-icon>
        <span style="font-weight: 600; font-size: 18px; color: #E7E3FC;">{{ title }}</span>
      </div>

      <div class="mb-6">
        <span style="color: #E7E3FC; font-size: 16px; font-weight: 500;">{{ inputLabel }}</span>
        <v-text-field
          v-model="mileage"
          type="number"
          outlined
          dense
          :placeholder="placeholder"
          class="mt-2"
          :rules="[v => !!v || 'Campo obrigatório', v => v > 0 || 'Valor deve ser maior que zero']"
          @keyup.enter="saveMileage"
        ></v-text-field>
      </div>

      <div
        class="d-flex justify-end"
        style="gap: 12px;"
      >
        <v-btn
          outlined
          color="#E7E3FC"
          @click="closeModal"
        >
          CANCELAR
        </v-btn>
        <v-btn
          color="info"
          :loading="isSubmitting"
          :disabled="!mileage || mileage <= 0 || isSubmitting"
          @click="saveMileage"
        >
          SALVAR
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import axiosNewInstance from '@/plugins/newAxiosInstance'
import {
  mdiClose,
  mdiSpeedometer,
} from '@mdi/js'

export default {
  name: 'OdometerModal',
  props: {
    title: {
      type: String,
      default: 'Quilometragem inicial',
    },
    inputLabel: {
      type: String,
      default: 'Km inicial',
    },
    placeholder: {
      type: String,
      default: 'Digite a quilometragem inicial',
    },
    checklistId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      icons: {
        mdiClose,
        mdiSpeedometer,
      },
      mileage: '',
      isSubmitting: false,
    }
  },
  methods: {
    closeModal() {
      this.mileage = ''
      this.$emit('close')
    },
    async saveMileage() {
      if (!this.mileage || this.mileage <= 0 || !this.checklistId) {
        this.$swal({
          icon: 'warning',
          title: 'Atenção',
          text: 'Preencha os campos corretamente antes de salvar.',
        })

        return
      }

      this.isSubmitting = true

      try {
        const payload = {
          odometer_km: parseFloat(this.mileage),
        }

        const response = await axiosNewInstance.patch(
          `/api/v1/solicitations/transport_vehicle_checklist/approve_odometer/${this.checklistId}`,
          payload,
        )

        this.$emit('odometer-approved', response.data)

        this.$swal({
          icon: 'success',
          title: 'Sucesso',
          text: 'Hodômetro registrado com sucesso!',
          timer: 2000,
          showConfirmButton: false,
        })

        this.mileage = ''
        this.$emit('close')
      } catch (error) {
        console.error('Erro ao salvar hodômetro:', error)

        const errorMessage = error.message || 'Não foi possível registrar o hodômetro. Tente novamente.'

        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: errorMessage,
        })
      } finally {
        this.isSubmitting = false
      }
    },
  },
}
</script>

<style scoped>
.modal-header {
  width: 100%;
  position: relative;
}

.close-button {
  position: absolute;
  right: 20px;
  top: 25px;
}
</style>
